var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.36ce29922f02b9dfa4602cfe90afc613.svg#k';
                    var viewUrl = 'sprites.36ce29922f02b9dfa4602cfe90afc613.svg#view-k';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 19 18',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };